/* eslint-disable no-unused-vars */
import React from 'react'

export default function AllPricing() {
  return (
    <div>AllPricing</div>
  )
}
